/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_TitleInputs */

const en_settings_integrations_zotero_title = /** @type {(inputs: Settings_Integrations_Zotero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero`)
};

const es_settings_integrations_zotero_title = /** @type {(inputs: Settings_Integrations_Zotero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero`)
};

/**
* | output |
* | --- |
* | "Zotero" |
*
* @param {Settings_Integrations_Zotero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_title = /** @type {((inputs?: Settings_Integrations_Zotero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_title(inputs)
	return en_settings_integrations_zotero_title(inputs)
});